import createPermission from 'permissions/createPermission'
import list from 'permissions/centralStations/list'
import {edit} from 'permissions/centralStations/actions'

export const general = createPermission('groups.list')
export const stations = createPermission(list, edit)

export default createPermission(general, stations)